<template>
  <div>
    <div v-if="hasRoleComprador && !loading && hasProdutosAdicionaveisCarrinho"
         class="d-flex justify-end">
      <div class="d-flex mr-3 mb-2">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on"
                    color="success"
                    class="mr-4 normal-btn-text rounded-tag-small elevation-0"
                    :loading="loadingCarrinho"
                    @click="adicionarTodosAoCarrinho()">
              <v-icon small>mdi-cart-check</v-icon>
              Adicionar menor preço
            </v-btn>
          </template>
          <span>Adiciona os produtos com menor preço ao carrinho</span>
        </v-tooltip>
        <px-carrinho-matriz :produtos="produtos"
                            @update-carrinho="onUpdateCarrinho">
          <template v-slot:activator="{ on }">
            <v-btn color="primary"
                   class="normal-btn-text rounded-tag-small elevation-0"
                   v-on="on">
              <v-icon small>
                mdi-cart-variant
              </v-icon>
              Carrinho
            </v-btn>
          </template>
        </px-carrinho-matriz>
      </div>
    </div>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && (!header || !header.length)"
         align="center"
         class="headline mb-5">
      Nenhuma resposta encontrada
    </div>
    <v-simple-table
      v-if="!loading && header && header.length"
      fixed-header>
      <template v-slot:default>
        <thead>
        <tr>
          <th class="text-center">-</th>
          <template v-if="isTipoProduto">
            <th class="text-center" v-for="column in header" :key="column.id">
              {{ column.pessoa.nome }}
              <span style="width: 20px;" class="text-left d-inline-block"
                v-if="respostaProdutosFornecedor(column).length > 0">
                <px-show-fornecedor-com-difal small
                  :produtos="respostaProdutosFornecedor(column)"/>
              </span>
              <px-negociacao-modal v-if="hasRoleComprador"
                                   :resposta="respostaFornecedor(column)">
                <template v-slot:activator="{ on }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on: onTooltip }">
                      <v-btn icon
                             small
                             v-on="{...on, ...onTooltip}">
                        <v-icon size="20">mdi-handshake</v-icon>
                      </v-btn>
                    </template>
                    <span>Negociar</span>
                  </v-tooltip>
                </template>
              </px-negociacao-modal>
              <v-tooltip v-if="hasRoleComprador
                         && fornecedorHasProdutosAdicionaveisCarrinho(column.id)"
                         top>
                <template v-slot:activator="{ on }">
                  <v-btn icon
                         small
                         v-on="on"
                         :loading="loadingCarrinho"
                         @click="fornecedorAdicionarTodosAoCarrinho(column.id)">
                    <v-icon size="20">mdi-cart-variant</v-icon>
                  </v-btn>
                </template>
                <span>
                  Adicionar todos os produtos deste fornecedor ao carrinho
                </span>
              </v-tooltip>
            </th>
          </template>
          <template v-else>
            <th class="text-center" v-for="column in header" :key="column.id">
              <px-produto-descricao :especificacao="column.especificacaoProduto"
                                    :produto="column.produto"/>
              <v-tooltip top v-if="showEspecificacao">
                <template v-slot:activator="{ on }">
                  <v-icon small v-on="on">mdi-file-document-outline</v-icon>
                </template>
                <span>{{ column.especificacaoProduto }}</span>
              </v-tooltip>
              <px-historico-preco-produto small
                                          :produto="column.produto"
                                          :unidade-medida="column.produto.unidadeMedida"/>
              <px-show-fornecedores-homologados-produto small :produto="column"/>
              <div v-if="showEspecificacao" class="caption">
                {{ column.especificacaoProduto | truncate(50) }}
              </div>
            </th>
            <th style="min-width: 150px;" class="font-weight-bold text-center">Total</th>
            <th class="text-center">Ações</th>
          </template>
        </tr>
        </thead>
        <tbody>
          <template v-if="isTipoProduto">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <tr class="font-weight-bold"
                  style="cursor: pointer"
                  v-on="on"
                  @click="showDetalhesTotaisHeader = !showDetalhesTotaisHeader">
                  <td class="text-left">
                    Total
                    <v-icon small class="ml-2">
                      {{ showDetalhesTotaisHeader ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </td>
                  <td class="text-center p-relative"
                      style="position: relative;"
                      v-for="(resposta, index) in respostasTotais"
                      :key="resposta.id">
                    <span style="display: inline-block; width: 100%;">
                      {{ resposta.valorMoedaConvertido.total
                        | currency('R$', getCasasDecimais(resposta)) }}
                    </span>
                    <v-icon small class="ml-2" v-if="index === respostasTotais.length - 1"
                      style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%);"
                    >
                      {{ showDetalhesTotaisHeader ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </td>
                </tr>
              </template>
              <span>Mostrar detalhes</span>
            </v-tooltip>
            <tr v-if="showDetalhesTotaisHeader">
              <td class="caption font-weight-bold text-left">
                <div>Total produtos</div>
                <div>Total ICMS</div>
                <div>Total IPI</div>
                <div>Total DIFAL (*)</div>
              </td>
              <td class="caption font-weight-bold text-center"
                v-for="resposta in respostasTotais"
                :key="resposta.id">
                <div>
                  {{ resposta.valorMoedaConvertido.totalProdutos
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
                <div>
                  {{ resposta.valorMoedaConvertido.totalIcms
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
                <div>
                  {{ resposta.valorMoedaConvertido.totalIpi
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
                <div>
                  {{ resposta.valorMoedaConvertido.totalDifal
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
              </td>
            </tr>
            <tr v-for="produtoFornecedor in produtosGrid" :key="produtoFornecedor.id">
              <td class="text-left">
                <div class="d-flex align-center">
                  <px-produto-descricao
                    :especificacao="produtoFornecedor.produto.cotacaoProduto.especificacaoProduto"
                    :produto="produtoFornecedor.produto.cotacaoProduto.produto"/>
                  <px-situacao-cotacao-icon
                    :situacao="produtoFornecedor.produto.cotacaoProduto.situacao"/>
                  <px-show-fornecedores-homologados-produto
                    small
                    :produto="produtoFornecedor.produto.cotacaoProduto.produto"/>
                  <px-historico-preco-produto
                    small
                  :produto="produtoFornecedor.produto.cotacaoProduto.produto"
                  :unidade-medida="produtoFornecedor.produto.cotacaoProduto.produto.unidadeMedida"/>
                </div>
                <div class="caption">
                  ({{ produtoFornecedor.produto.cotacaoProduto.quantidade
                    | number(getCurrencyFormat(produtoFornecedor.produto.cotacaoProduto)) }}
                    {{ produtoFornecedor.produto.cotacaoProduto.unidadeMedida.descricao }})
                </div>
                <div v-if="showEspecificacao" class="caption ml-1 mb-1">
                  {{ produtoFornecedor.produto.cotacaoProduto.especificacaoProduto | truncate(50) }}
                </div>
              </td>
              <td v-for="fornecedorProduto in produtoFornecedor.fornecedores"
                  :key="fornecedorProduto.id">
                <div class="d-flex justify-center align-center">
                  <div class="text-center">
                    <px-matriz-item :has-preco="hasPreco"
                                    :has-prazo="hasPrazo"
                                    :has-frete="hasFrete"
                                    :hide-icms="showPrecoSemIcms"
                                    :show-difal="showPrecoComDifal"
                                    :show-ipi="showPrecoComIpi"
                                    :has-especificacao="showEspecificacaoFornecedor"
                                    :show-percentual-icms="showPercentualIcms"
                                    :show-preco-target="showPrecoTarget"
                                    :produto="fornecedorProduto"/>
                  </div>
                  <v-tooltip v-if="hasRoleComprador
                            && isAdicionavelCarrinho(fornecedorProduto.produto)
                            && fornecedorProduto.produto.precoUnitario > 0"
                            top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon
                            small
                            v-on="on"
                            :loading="loadingCarrinho"
                            @click="adicionarAoCarrinho(fornecedorProduto)">
                        <v-icon size="15">mdi-cart</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Adicionar produto ao carrinho
                    </span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <tr class="font-weight-bold"
                  style="cursor: pointer"
                  v-on="on"
                  @click="showDetalhesTotaisFooter = !showDetalhesTotaisFooter">
                  <td class="text-left">
                    Total
                    <v-icon small class="ml-2">
                      {{ showDetalhesTotaisFooter ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </td>
                  <td class="text-center p-relative"
                      style="position: relative;"
                      v-for="(resposta, index) in respostasTotais"
                      :key="resposta.id">
                    <span style="display: inline-block; width: 100%;">
                      {{ resposta.valorMoedaConvertido.total
                        | currency('R$', getCasasDecimais(resposta)) }}
                    </span>
                    <v-icon small class="ml-2" v-if="index === respostasTotais.length - 1"
                      style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%);"
                    >
                      {{ showDetalhesTotaisFooter ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                    </v-icon>
                  </td>
                </tr>
              </template>
              <span>Mostrar detalhes</span>
            </v-tooltip>
            <tr v-if="showDetalhesTotaisFooter">
              <td class="caption font-weight-bold text-left">
                <div>Total produtos</div>
                <div>Total ICMS</div>
                <div>Total IPI</div>
                <div>Total DIFAL (*)</div>
              </td>
              <td class="caption font-weight-bold text-center"
                v-for="resposta in respostasTotais"
                :key="resposta.id">
                <div>
                  {{ resposta.valorMoedaConvertido.totalProdutos
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
                <div>
                  {{ resposta.valorMoedaConvertido.totalIcms
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
                <div>
                  {{ resposta.valorMoedaConvertido.totalIpi
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
                <div>
                  {{ resposta.valorMoedaConvertido.totalDifal
                      | currency('R$', getCasasDecimais(resposta)) }}
                </div>
              </td>
            </tr>
            <span class="caption">
              (*) DIFAL não incluso no total. Recolhimento feito à parte.
            </span>
          </template>
          <template v-if="!isTipoProduto">
            <tr v-for="fornecedor in fornecedores" :key="fornecedor.id">
              <td class="text-center">
                {{ fornecedor.fornecedor.pessoa.nome | truncate(25) }}
              </td>
              <td class="text-center" v-for="produto in fornecedor.produtos" :key="produto.id">
                <div class="d-flex justify-center align-center">
                  <px-matriz-item :has-preco="hasPreco"
                                  :has-prazo="hasPrazo"
                                  :has-frete="hasFrete"
                                  :hide-icms="showPrecoSemIcms"
                                  :show-difal="showPrecoComDifal"
                                  :show-ipi="showPrecoComIpi"
                                  :has-especificacao="showEspecificacaoFornecedor"
                                  :show-percentual-icms="showPercentualIcms"
                                  :show-preco-target="showPrecoTarget"
                                  :produto="produto"/>
                  <v-tooltip v-if="hasRoleComprador
                             && isAdicionavelCarrinho(produto.produto)
                             && produto.produto.precoUnitario > 0"
                             top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon
                             small
                             v-on="on"
                             :loading="loadingCarrinho"
                             @click="adicionarAoCarrinho(produto.produto)">
                        <v-icon size="15">mdi-cart</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Adicionar produto ao carrinho
                    </span>
                  </v-tooltip>
                </div>
              </td>
              <td class="text-center">
                {{
                respostaTotaisFornecedor(fornecedor.fornecedor).valorMoedaConvertido.total
                  | currency(
                    'R$',
                    getCasasDecimais(respostaTotaisFornecedor(fornecedor.fornecedor)))
                }}
              </td>
              <td>
                <div class="d-flex justify-center align-center">
                  <px-negociacao-modal v-if="hasRoleComprador"
                                      :resposta="respostaFornecedor(fornecedor.fornecedor)">
                    <template v-slot:activator="{ on }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on: onTooltip }">
                          <v-btn icon
                                size="20"
                                v-on="{...on, ...onTooltip}">
                            <v-icon>mdi-handshake</v-icon>
                          </v-btn>
                        </template>
                        <span>Negociar</span>
                      </v-tooltip>
                    </template>
                  </px-negociacao-modal>
                  <v-tooltip v-if="hasRoleComprador
                             && fornecedorHasProdutosAdicionaveisCarrinho(fornecedor.fornecedor.id)"
                             top>
                    <template v-slot:activator="{ on }">
                      <v-btn icon
                             small
                             v-on="on"
                             :loading="loadingCarrinho"
                             @click="fornecedorAdicionarTodosAoCarrinho(fornecedor.fornecedor.id)">
                        <v-icon size="20">mdi-cart-variant</v-icon>
                      </v-btn>
                    </template>
                    <span>
                      Adicionar todos os produtos disponiveis deste fornecedor ao carrinho
                    </span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
import Vue from 'vue';
import { SituacaoRespostaCotacaoProduto, SituacaoCotacao } from 'px-business-components';
import { CasaDecimalUtils, DetalheFornecedorUtils } from 'px-components';
import { mapGetters, mapActions } from 'vuex';
import { GET_ITENS, ADD_ITEM } from '@/store/carrinho/actions.type';
import {
  groupBy, minBy, first, uniqBy, map, orderBy, find, isEmpty,
} from 'lodash';
import currency from 'currency.js';
import CarrinhoService from '@/modules/carrinho/carrinho-service';
import { isFornecedorHomologado, filterProdutoNaoHomologado } from '@/utils/fornecedor-produto-utils';
import { setMelhorPrazoPagamento, setMelhorFrete, buildTotais } from './matriz-utils';
import MatrizService from './matriz-service';
import PxMatrizItem from './components/PxMatrizItem.vue';
import CarrinhoMatriz from './carrinho/CarrinhoMatriz.vue';
import NegociacaoModal from '../negociacao/modal/NegociacaoModal.vue';

const TIPO_MATRIZ = {
  PRODUTO: 'PRODUTO',
  FORNECEDOR: 'FORNECEDOR',
};

export default {
  data() {
    return {
      respostas: null,
      produtos: null,
      header: null,
      fornecedores: null,
      produtosGrid: null,
      loading: false,
      loadingCarrinho: false,
      showDetalhesTotaisHeader: false,
      showDetalhesTotaisFooter: false,
    };
  },
  computed: {
    ...mapGetters('matriz', ['cotacoes', 'viewType', 'stringFilter', 'cotacoesItens', 'showEspecificacao', 'showEspecificacaoFornecedor', 'showPrecoSemIcms', 'showPrecoComDifal', 'showPrecoComIpi', 'tipoVisualizacao', 'showPercentualIcms', 'showPrecoTarget', 'situacao']),
    ...mapGetters('user', ['hasRoleComprador']),
    hasPreco() {
      return this.viewType && this.viewType.includes('PRECO');
    },
    hasPrazo() {
      return this.viewType && this.viewType.includes('FORMA_PAGAMENTO');
    },
    hasFrete() {
      return this.viewType && this.viewType.includes('FRETE');
    },
    respostaFornecedor() {
      return fornecedor => this.respostas.find(r => r.fornecedor.id === fornecedor.id);
    },
    respostaProdutosFornecedor() {
      return fornecedor => this.respostas
        .filter(r => r.fornecedor.id === fornecedor.id)
        .flatMap(r => r.produtos)
        .filter(produto => produto.impostos.valorDifalConvertido > 0);
    },
    respostaTotaisFornecedor() {
      return fornecedor => this.respostasTotais.find(r => r.id === fornecedor.id);
    },
    isTipoProduto() {
      return this.tipoVisualizacao === 'PRODUTO';
    },
    respostasTotais() {
      return buildTotais(this.respostas, this.situacao);
    },
    getCasasDecimais() {
      return (resposta) => {
        const produtos = resposta.produtos.map(p => p.cotacaoProduto.produto);
        return CasaDecimalUtils.getCasaDecimal(produtos);
      };
    },
    hasProdutosAdicionaveisCarrinho() {
      if (!this.produtos || !this.produtos.length) {
        return false;
      }
      return this.produtos
        .some(matrizProduto => this.isAdicionavelCarrinho(matrizProduto.produto));
    },
    fornecedorHasProdutosAdicionaveisCarrinho() {
      return (idFornecedor) => {
        if (!this.produtos || !this.produtos.length) {
          return false;
        }
        return this.produtos
          .some(matrizProduto => this.isAdicionavelCarrinho(matrizProduto.produto)
            && matrizProduto.fornecedor.id === idFornecedor);
      };
    },
    isAdicionavelCarrinho() {
      return produto => produto.cotacaoProduto
        .situacao === SituacaoCotacao.keys.ABERTA.key && !produto.$adicionado;
    },
    getCurrencyFormat() {
      return cotacaoProduto => CasaDecimalUtils
        .getCurrencyFormat(cotacaoProduto.produto.casasDecimais);
    },
  },
  methods: {
    ...mapActions('carrinho', {
      getItens: GET_ITENS,
      addItem: ADD_ITEM,
    }),
    buildCotacoesParam() {
      if (!this.cotacoes || !this.cotacoes.length) {
        return [];
      }
      return this.cotacoes.map(cot => cot.id)
        .join(',');
    },
    onUpdateCarrinho() {
      this.getItens();
    },
    updateRespostas() {
      this.getRespostas();
    },
    filterItensProdutos(data) {
      if (isEmpty(this.cotacoesItens) || !data) {
        return data;
      }
      const ids = this.cotacoesItens.map(item => item.id);
      return data.map((resp) => {
        const resposta = { ...resp };
        resposta.produtos = resposta.produtos.filter(prod => ids.includes(prod.cotacaoProduto.id));
        return resposta;
      });
    },
    filterItensSituacaoProdutos(data) {
      if (isEmpty(this.situacao) || !data) {
        return data;
      }
      return data.map((resp) => {
        const resposta = { ...resp };
        resposta.produtos = resposta.produtos
          .filter(prod => this.situacao.includes(prod.cotacaoProduto.situacao));
        return resposta;
      });
    },
    filterRespostas(data) {
      let filteredRespostas = null;
      filteredRespostas = this.filterItensProdutos(data);
      filteredRespostas = this.filterItensSituacaoProdutos(filteredRespostas);
      return filteredRespostas;
    },
    getRespostas() {
      this.loading = true;
      MatrizService.getRespostas({
        cotacoes: this.buildCotacoesParam(),
        query: this.stringFilter,
      })
        .then(({ data }) => {
          this.respostas = this.filterRespostas(data);
          this.buildProdutos();
          this.setMelhorPreco();
          setMelhorPrazoPagamento(this.produtos);
          setMelhorFrete(this.produtos);
          this.buildHeader();
          this.buildFornecedores();
          this.buildProdutosGrid();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildprecoComIcmsIpi(produto) {
      if (produto.impostos?.ipi > 0) {
        return currency(produto.valorMoedaConvertido.precoUnitario)
          .multiply(produto.impostos.ipi)
          .add(produto.valorMoedaConvertido.precoUnitario).value;
      }
      return produto.valorMoedaConvertido.precoUnitario;
    },
    buildPrecoComIpiDifal(produto, precoUnitarioComIPI) {
      const precoUnitarioComDifal = currency(produto.impostos.valorDifalConvertido)
        .divide(produto.cotacaoProduto.quantidade)
        .add(precoUnitarioComIPI);

      if (!produto.impostos.icms) {
        return precoUnitarioComDifal.value;
      }

      const valorIcms = currency(produto.valorMoedaConvertido.precoUnitario)
        .multiply(produto.impostos.icms);

      return precoUnitarioComDifal.subtract(valorIcms).value;
    },
    buildPrecoComIpi(produto, precoUnitarioComIPI) {
      if (!produto.impostos.icms) {
        return precoUnitarioComIPI;
      }

      const valorIcms = currency(produto.valorMoedaConvertido.precoUnitario)
        .multiply(produto.impostos.icms);

      return currency(precoUnitarioComIPI).subtract(valorIcms).value;
    },
    buildPrecoSemTodos(produto) {
      if (!produto.impostos.icms) {
        return produto.valorMoedaConvertido.precoUnitario;
      }

      const valorIcms = currency(produto.valorMoedaConvertido.precoUnitario)
        .multiply(produto.impostos.icms);

      return currency(produto.valorMoedaConvertido.precoUnitario).subtract(valorIcms).value;
    },
    buildPrecoComTodos(produto, precoUnitarioComIPI) {
      const precoUnitarioComDifal = currency(produto.impostos.valorDifalConvertido)
        .divide(produto.cotacaoProduto.quantidade)
        .add(precoUnitarioComIPI);

      return precoUnitarioComDifal.value;
    },
    buildPrecoComDifal(produto) {
      const precoUnitarioComDifal = currency(produto.impostos.valorDifalConvertido)
        .divide(produto.cotacaoProduto.quantidade)
        .add(produto.valorMoedaConvertido.precoUnitario);

      if (!produto.impostos.icms) {
        return precoUnitarioComDifal.value;
      }

      const valorIcms = currency(produto.valorMoedaConvertido.precoUnitario)
        .multiply(produto.impostos.icms);

      return precoUnitarioComDifal.subtract(valorIcms).value;
    },
    buildPrecoComIcmsDifal(produto) {
      const precoUnitarioComDifal = currency(produto.impostos.valorDifalConvertido)
        .divide(produto.cotacaoProduto.quantidade)
        .add(produto.valorMoedaConvertido.precoUnitario);

      return precoUnitarioComDifal.value;
    },
    buildProdutos() {
      const produtos = [];
      this.respostas.forEach((resposta) => {
        resposta.produtos.forEach((produto) => {
          const precoComIcmsIpi = this.buildprecoComIcmsIpi(produto);
          const item = {
            produto: {
              ...produto,
              precoComIcmsIpi,
              precoComIpiDifal: this.buildPrecoComIpiDifal(produto, precoComIcmsIpi),
              precoComIpi: this.buildPrecoComIpi(produto, precoComIcmsIpi),
              precoComIcms: produto.valorMoedaConvertido.precoUnitario,
              precoComDifal: this.buildPrecoComDifal(produto),
              precoComIcmsDifal: this.buildPrecoComIcmsDifal(produto),
              precoComTodos: this.buildPrecoComTodos(produto, precoComIcmsIpi),
              precoSemTodos: this.buildPrecoSemTodos(produto),
            },
            resposta: {
              id: resposta.id,
              compra: resposta.compra,
              finalizado: resposta.finalizado,
              cotacao: {
                id: resposta.cotacao.id,
                detalhesFornecedores: resposta.cotacao.detalhesFornecedores,
                identificador: resposta.cotacao.identificador,
              },
              total: resposta.total,
              totalProdutos: resposta.totalProdutos,
              valorMoedaConvertido: {
                ...resposta.valorMoedaConvertido,
              },
              moeda: resposta.moeda,
            },
            fornecedor: resposta.fornecedor,
            formaPagamento: resposta.formaPagamento,
            prazoPagamento: resposta.prazoPagamento,
            frete: resposta.frete,
          };
          produtos.push(item);
        });
      });
      this.produtos = produtos;
    },
    resetProdutosMelhorPreco(produtos) {
      return produtos.forEach((produto) => {
        // eslint-disable-next-line no-param-reassign
        produto.$melhorPreco = false;
      });
    },
    setMelhorPreco() {
      const grupos = groupBy(this.produtos, 'produto.cotacaoProduto.id');
      Object.keys(grupos)
        .forEach((key) => {
          const produtos = grupos[key]
            .filter(prod => prod.produto.precoComIcms > 0);
          this.resetProdutosMelhorPreco(produtos);
          let precoUnitarioField = 'produto.precoSemTodos';
          if (this.showPrecoSemIcms && this.showPrecoComIpi && this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComIpiDifal';
          }
          if (!this.showPrecoSemIcms && this.showPrecoComIpi && this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComTodos';
          }
          if (this.showPrecoSemIcms && this.showPrecoComIpi && !this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComIpi';
          }
          if (this.showPrecoSemIcms && !this.showPrecoComIpi && this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComDifal';
          }
          if (!this.showPrecoSemIcms && this.showPrecoComIpi && !this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComIcmsIpi';
          }
          if (!this.showPrecoSemIcms && !this.showPrecoComIpi && this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComIcmsDifal';
          }
          if (!this.showPrecoSemIcms && !this.showPrecoComIpi && !this.showPrecoComDifal) {
            precoUnitarioField = 'produto.precoComIcms';
          }
          const cheaper = minBy(produtos, precoUnitarioField);
          if (!cheaper) {
            return;
          }
          cheaper.$melhorPreco = true;
        });
    },
    buildHeader() {
      if (this.tipoVisualizacao === TIPO_MATRIZ.PRODUTO) {
        const fornecedores = uniqBy(this.produtos, 'fornecedor.id');
        this.header = orderBy(map(fornecedores, (fornecedor) => {
          const { detalhesFornecedores } = first(this.respostas).cotacao;
          return this.buildFornecedor(fornecedor.fornecedor, detalhesFornecedores);
        }), 'id');

        return;
      }
      const produtos = uniqBy(this.produtos, 'produto.cotacaoProduto.id');
      this.header = orderBy(map(produtos, 'produto.cotacaoProduto'), 'id');
    },
    buildFornecedores() {
      const fornecedores = groupBy(this.produtos, 'fornecedor.id');
      this.fornecedores = map(fornecedores, this.mapFornecedores);
    },
    buildProdutosGrid() {
      const produtos = groupBy(this.produtos, 'produto.cotacaoProduto.id');
      this.produtosGrid = map(produtos, this.mapProdutos);
    },
    mapProdutos(produtos) {
      const result = {
        produto: first(produtos).produto,
      };
      result.fornecedores = this.header.map((fornecedor) => {
        const found = find(produtos, toFind => toFind.fornecedor.id === fornecedor.id);
        if (!found) {
          return this.createProduto(fornecedor, result.produto.cotacaoProduto);
        }
        return found;
      });
      result.fornecedores = orderBy(result.fornecedores, 'fornecedor.id');
      return result;
    },
    buildFornecedor(fornecedor, detalhesFornecedores) {
      const detalhe = DetalheFornecedorUtils.getDetalhe(fornecedor.id, detalhesFornecedores);
      return {
        ...fornecedor,
        codigoInterno: detalhe.codigoInterno,
        pessoa: {
          ...fornecedor.pessoa,
          nome: detalhe.nome || fornecedor.pessoa.nome,
        },
      };
    },
    mapFornecedores(forn) {
      const { detalhesFornecedores } = first(this.respostas).cotacao;
      const result = {
        fornecedor: this.buildFornecedor(first(forn).fornecedor, detalhesFornecedores),
      };
      result.produtos = this.header.map((prod) => {
        const found = find(forn, toFind => toFind.produto.cotacaoProduto.id === prod.id);
        if (!found) {
          return this.createProduto(result.fornecedor, prod);
        }
        return found;
      });
      result.produtos = orderBy(result.produtos, 'produto.cotacaoProduto.id');
      return result;
    },
    createProduto(fornecedor, cotacaoProduto) {
      return {
        formaPagamento: null,
        prazoPagamento: null,
        fornecedor,
        produto: {
          precoUnitario: null,
          impostos: {
            valorDifal: 0,
            valorDifalConvertido: 0,
          },
          cotacaoProduto,
          situacao: SituacaoRespostaCotacaoProduto.keys.NAO_RESPONDIDA.key,
        },
      };
    },
    isFornecedorHomologadoAoProduto(produto, idFornecedor) {
      const { fornecedoresProduto } = produto.cotacaoProduto.produto;
      if (isEmpty(fornecedoresProduto)
        || isEmpty(fornecedoresProduto.filter(fp => fp.homologado))) {
        return true;
      }
      return isFornecedorHomologado(fornecedoresProduto, idFornecedor);
    },
    getProdutosNaoHomologados(idFornecedor) {
      return this.produtos
        .map(p => p.produto.cotacaoProduto.produto)
        .filter(p => filterProdutoNaoHomologado(p, idFornecedor));
    },
    adicionarAoCarrinho(matrizProduto) {
      // Verifica se o produto está homologado ao fornecedor
      if (!this.isFornecedorHomologadoAoProduto(
        matrizProduto.produto,
        matrizProduto.fornecedor.id,
      )) {
        const especificacao = matrizProduto.produto.cotacaoProduto.especificacaoProduto;
        const { descricao, isGenerico } = matrizProduto.produto.cotacaoProduto.produto;
        const nomeProduto = isGenerico ? especificacao : descricao;

        const nomeFornecedor = matrizProduto.fornecedor.pessoa.nome;

        this.$toast(`Fornecedor:
        ${nomeFornecedor} não é homologado ao produto: ${nomeProduto}`, { color: 'error' });
        return;
      }

      this.loadingCarrinho = true;
      const idRespostaProduto = matrizProduto.produto.id;

      this.addItem(idRespostaProduto)
        .then(() => {
          // Filtra pelos mesmo produto que esta na cotação
          // Aplica a flag temporário $adicionado para indicar que
          // O produto foi adicionado ao carrinho
          this.produtos
            .filter(p => p.produto.cotacaoProduto.id === matrizProduto.produto.cotacaoProduto.id)
            .forEach(p => Vue.set(p.produto, '$adicionado', true));
          this.$toast('Produto adicionado ao carrinho', { color: 'success' });
        })
        .finally(() => {
          this.loadingCarrinho = false;
        });
    },
    adicionarTodosAoCarrinho() {
      const mapIds = this.produtos
        .filter(produto => !!produto.$melhorPreco)
        .filter(matrizProduto => this.isAdicionavelCarrinho(matrizProduto.produto)
          && this.isFornecedorHomologadoAoProduto(
            matrizProduto.produto,
            matrizProduto.fornecedor.id,
          ))
        .map(matrizProduto => ({
          idRespostaProduto: matrizProduto.produto.id,
          idCotacaoProduto: matrizProduto.produto.cotacaoProduto.id,
        }));

      if (mapIds.length === 0) {
        // Filtra pelos produtos não homologados
        const produtos = this.produtos.filter(matrizProduto => !this
          .isFornecedorHomologadoAoProduto(
            matrizProduto.produto,
            matrizProduto.fornecedor.id,
          ) && this.isAdicionavelCarrinho(matrizProduto.produto));
        // Pra cada produto na matriz que não é homologado ao fornecedor manda uma mensagem de erro
        // Pois podem ser fornecedores diferentes com os melhores preços
        produtos.forEach((matrizProduto) => {
          const nomeFornecedor = matrizProduto.fornecedor.pessoa.nome;
          const especificacao = matrizProduto.produto.cotacaoProduto.especificacaoProduto;
          const { descricao, isGenerico } = matrizProduto.produto.cotacaoProduto.produto;
          const nomeProduto = isGenerico ? especificacao : descricao;

          this.$toast(`Fornecedor: ${nomeFornecedor} não é homologado para o produto: ${nomeProduto}`, { color: 'error' });
        });
        return;
      }

      this.loadingCarrinho = true;

      const ids = mapIds.map(m => m.idRespostaProduto);
      const cotacaoIds = mapIds.map(m => m.idCotacaoProduto);

      CarrinhoService.adicionarTodosProdutos(ids)
        .then(() => {
          this.produtos
            .filter(p => cotacaoIds.includes(p.produto.cotacaoProduto.id))
            .forEach(p => Vue.set(p.produto, '$adicionado', true));
          this.$toast('Produtos com o menor preço adicionados ao carrinho', { color: 'success' });
        })
        .finally(() => {
          this.onUpdateCarrinho();
          this.loadingCarrinho = false;
        });
    },
    fornecedorAdicionarTodosAoCarrinho(idFornecedor) {
      const ids = this.produtos
        .filter(matrizProduto => matrizProduto.fornecedor.id === idFornecedor)
        .filter(matrizProduto => this.isAdicionavelCarrinho(matrizProduto.produto)
          && this.isFornecedorHomologadoAoProduto(
            matrizProduto.produto,
            idFornecedor,
          ))
        .map(matrizProduto => matrizProduto.produto.id);

      if (ids.length === 0) {
        // Filtra pelos produtos não homologados
        const produtos = this.produtos
          .filter(matrizProduto => matrizProduto.fornecedor.id === idFornecedor)
          .filter(matrizProduto => !this
            .isFornecedorHomologadoAoProduto(
              matrizProduto.produto,
              idFornecedor,
            ) && this.isAdicionavelCarrinho(matrizProduto.produto));
        // Pra cada produto na matriz que não é homologado ao fornecedor manda uma mensagem de erro
        // Pois podem ser fornecedores diferentes com os melhores preços
        produtos.forEach((matrizProduto) => {
          const nomeFornecedor = matrizProduto.fornecedor.pessoa.nome;
          const especificacao = matrizProduto.produto.cotacaoProduto.especificacaoProduto;
          const { descricao, isGenerico } = matrizProduto.produto.cotacaoProduto.produto;
          const nomeProduto = isGenerico ? especificacao : descricao;

          this.$toast(`Fornecedor: ${nomeFornecedor} não é homologado para o produto: ${nomeProduto}`, { color: 'error' });
        });
        return;
      }

      CarrinhoService.adicionarTodosProdutos(ids)
        .then(() => {
          this.produtos.filter(p => ids.includes(p.produto.id)).forEach(p => Vue.set(p.produto, '$adicionado', true));
          this.$toast('Produtos adicionados ao carrinho com sucesso', { color: 'success' });
        })
        .finally(() => {
          this.onUpdateCarrinho();
          this.loadingCarrinho = false;
        });
    },
  },
  watch: {
    showPrecoSemIcms(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setMelhorPreco();
    },
    showPrecoComDifal(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setMelhorPreco();
    },
    showPrecoComIpi(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.setMelhorPreco();
    },
    tipoVisualizacao(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.getRespostas();
    },
  },
  created() {
    this.getRespostas();
  },
  components: {
    PxMatrizItem,
    PxNegociacaoModal: NegociacaoModal,
    PxCarrinhoMatriz: CarrinhoMatriz,
  },
};
</script>
